import { Link } from "react-router-dom";
import { 
  Check, 
  Calendar, 
  MapPin, 
  Clock,
  Heart,
  Instagram,
  Mail,
  Euro
} from "lucide-react";

const VendorThankYouPage = () => {
  return (
    <div className="min-h-screen bg-[#FAF7F2] font-body">
      {/* Hero Section */}
      <section className="px-4 py-12 md:py-20">
        <div className="max-w-lg mx-auto">
          {/* Success Icon */}
          <div 
            className="w-20 h-20 rounded-full bg-[#8B2332] flex items-center justify-center mx-auto mb-8 animate-scale-in"
            data-testid="vendor-success-icon"
          >
            <Check className="w-10 h-10 text-white" />
          </div>

          {/* Headline */}
          <h1 
            className="font-heading text-4xl md:text-5xl text-[#2D2D2D] text-center mb-4"
            data-testid="vendor-thank-you-headline"
          >
            Bewerbung eingegangen!
          </h1>

          <p className="text-[#6B6B6B] text-center text-lg mb-12">
            Danke für dein Interesse am Hijab & Halal Pop-up.
          </p>

          {/* Next Steps Card */}
          <div 
            className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-[#EFEBE5] mb-8"
            data-testid="vendor-next-steps-card"
          >
            <h2 className="font-heading text-2xl text-[#2D2D2D] mb-6">
              Was jetzt passiert
            </h2>

            <div className="space-y-6">
              {/* Step 1 */}
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#8B2332]/10 flex items-center justify-center">
                  <Mail className="w-5 h-5 text-[#8B2332]" />
                </div>
                <div>
                  <h3 className="font-medium text-[#2D2D2D] mb-1">
                    Wir prüfen deine Bewerbung
                  </h3>
                  <p className="text-[#6B6B6B] text-sm">
                    Du hörst innerhalb weniger Tage von uns.
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#8B2332]/10 flex items-center justify-center">
                  <Euro className="w-5 h-5 text-[#8B2332]" />
                </div>
                <div>
                  <h3 className="font-medium text-[#2D2D2D] mb-1">
                    Standgebühren & Details
                  </h3>
                  <p className="text-[#6B6B6B] text-sm">
                    Standgebühren starten ab 250 € inkl. MwSt. je nach Standgröße. 
                    Wir besprechen die genauen Konditionen mit dir.
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#8B2332]/10 flex items-center justify-center">
                  <Calendar className="w-5 h-5 text-[#8B2332]" />
                </div>
                <div>
                  <h3 className="font-medium text-[#2D2D2D] mb-1">
                    Event-Details
                  </h3>
                  <div className="flex flex-wrap gap-2 mt-2">
                    <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-[#FAF7F2] rounded-full text-xs text-[#2D2D2D] border border-[#EFEBE5]">
                      <Calendar className="w-3 h-3 text-[#8B2332]" />
                      So, 08.02.2026
                    </span>
                    <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-[#FAF7F2] rounded-full text-xs text-[#2D2D2D] border border-[#EFEBE5]">
                      <Clock className="w-3 h-3 text-[#8B2332]" />
                      11–19 Uhr
                    </span>
                    <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-[#FAF7F2] rounded-full text-xs text-[#2D2D2D] border border-[#EFEBE5]">
                      <MapPin className="w-3 h-3 text-[#8B2332]" />
                      Grand Palais, Hamburg
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Instagram Follow */}
          <div 
            className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-[#EFEBE5] text-center"
            data-testid="vendor-follow-block"
          >
            <Instagram className="w-10 h-10 text-[#8B2332] mx-auto mb-4" />
            <h2 className="font-heading text-2xl text-[#2D2D2D] mb-2">
              Folge @edytandbloom
            </h2>
            <p className="text-[#6B6B6B] text-sm mb-6">
              Für Updates und Behind-the-Scenes.
            </p>

            <a
              href="https://www.instagram.com/edytandbloom/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block"
            >
              <button
                className="bg-gradient-to-r from-[#833AB4] via-[#FD1D1D] to-[#F77737] hover:opacity-90 text-white rounded-full px-8 py-3 font-medium transition-all inline-flex items-center gap-2"
                data-testid="vendor-instagram-button"
              >
                <Instagram className="w-4 h-4" />
                Auf Instagram folgen
              </button>
            </a>
          </div>

          {/* Back to Home */}
          <div className="text-center mt-8">
            <Link 
              to="/pass" 
              className="text-[#8B2332] hover:underline font-medium"
              data-testid="vendor-back-link"
            >
              Zurück zur Startseite
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 px-4 bg-white border-t border-[#EFEBE5]">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-2 text-[#6B6B6B]">
              <Heart className="w-4 h-4 text-[#8B2332]" />
              <span className="font-medium text-[#2D2D2D]">EDYT & BLOOM</span>
            </div>
            
            <div className="flex items-center gap-6 text-sm">
              <Link to="/impressum" className="text-[#6B6B6B] hover:text-[#8B2332] transition-colors">
                Impressum
              </Link>
              <Link to="/datenschutz" className="text-[#6B6B6B] hover:text-[#8B2332] transition-colors">
                Datenschutz
              </Link>
              <a 
                href="https://www.instagram.com/edytandbloom/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#6B6B6B] hover:text-[#8B2332] transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default VendorThankYouPage;
